module.exports = __webpack_public_path__ + "static/img/nav-2.7e555cf4.svg";